<template>
   <div>
       <businessAdd v-if="addBusinessDialogVisible"   :dialogVisible.sync="addBusinessDialogVisible" @refresh-list="successRefresh"/>
       <businessEdit v-if="editBusinessDialogVisible"  :dialogVisible.sync="editBusinessDialogVisible" :project_id="related_id"  @refresh-list="successRefresh"/>
       <changeThePerson v-if="changeThePersonDialogVisible" :project_ids="related_ids"  :dialogVisible.sync="changeThePersonDialogVisible"  @refresh="successRefresh"/>
       <addMember v-if="addMemberDialogVisible"  :project_ids="related_ids"    :dialogVisible.sync="addMemberDialogVisible" @refresh="successRefresh"/>
        <!--填写阶段任务-->
       <el-dialog v-if="stageTaskDialogVisible"
                  :before-close="handleClickStageTaskDialogCancel"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                  :visible.sync="stageTaskDialogVisible"
                  class="custom_form_dialog custom-form-dialog"
                  title="填写阶段任务"
                  width="560px">
           <div class="custom_form_body">
               <CustomFormPc ref="stage_task_form"
                             :field_list="stageTaskFieldsList"
                             :form_detail="stageTaskFieldsFormDetail"
                             :is_form_module="true"
                             :pk_id="currentProjectStageId"
                             @submit-form="submitTaskFormData"/>
           </div>
           <div slot="footer">
               <el-button size="small" @click="handleClickStageTaskDialogCancel">取消</el-button>
               <el-button :disabled="btnDisabled"
                          size="small"
                          type="primary"
                          @click="handleClickStageTaskDialogConfirm">
                   确定
               </el-button>
           </div>
       </el-dialog>

       <quotationTemplate v-if="addQuotationDialogVisible"  :dialogVisible.sync="addQuotationDialogVisible"/>

        <!-- 出库详情-->
       <OutProductDetail :outProductDetailDialog.sync="outProductDetailDialog" v-if="outProductDetailDialog" :outColumnId="related_id"/>
       <!--入库详情-->
       <InProductDetail :inProductDetailDialog.sync="inProductDetailDialog" v-if="inProductDetailDialog" :inColumnId="related_id"></InProductDetail>
       <!--采购详情-->
       <PurchaseDetail :purchaseDetailVisible.sync="purchaseDetailVisible" v-if="purchaseDetailVisible" :purchaseId="related_id"/>
       <!--  关联功能 -- 关联商机、关联订单、关联工单、关联审批、新增审批-->
       <RelateForm :relateFormDialog.sync="relateFormDialog" v-if="relateFormDialog" :relateType="relatedHandleType" :projectId="projectId" :projectDetail="projectDetail" @success="successRefresh"/>
        <!--添加编辑成员-->
       <MemberTpl v-if="memberDialog"  :projectId="projectId"  :projectMemberId="related_id" :projectMemberInfo="relatedHandleInfo" :memberDialog.sync="memberDialog" @success="successRefresh"/>

       <!--新增订单-->
       <OrderAdd v-if="addOrderDialogVisible" :dialogVisible.sync="addOrderDialogVisible"  @refresh-list="successRefresh"/>
        <!--编辑订单-->
       <OrderEdit v-if="editOrderDialogVisible"   :dialogVisible.sync="editOrderDialogVisible" :order_id="related_id"  @refresh-list="successRefresh"/>
        <!--订单售后-->
       <orderAfterSale v-if="orderAfterSaleDialog" :dialogVisible.sync="orderAfterSaleDialog"  :order_id="related_id" :orderInfo="orderAfterSaleInfo"  @order_edit="handleClickEditOrder"  @refresh="successRefresh"/>

       <!--新增回款-->
       <RepaymentDialog v-if="repaymentDialogVisible" :receivable_no.sync="related_num"  :projectId="projectId" :dialogVisible.sync="repaymentDialogVisible"  @refresh="successRefresh"/>
       <!--回款详情-->
       <RepaymentDetail v-if="repaymentDetailDialogVisible" :dialogVisible.sync="repaymentDetailDialogVisible" :receivable_no="related_num"/>
       <!--新增开票-->
       <InvoiceDialog v-if="invoiceDialogVisible" :invoice_no.sync="related_num"  :projectId="projectId" :dialogVisible.sync="invoiceDialogVisible" @refresh="successRefresh"/>
       <!--开票详情-->
       <InvoiceDetailsDialog v-if="invoiceDetailsDialogVisible"  :dialogVisible.sync="invoiceDetailsDialogVisible" :invoice_no="related_num"/>
       <!--产品成本详情明细-->
       <ProductCostDetail v-if="productCostDetailDialog"  :projectId="projectId" :productCostDetailDialog.sync="productCostDetailDialog"/>
       <!--订单代采详情-->
       <OrderPurchaseDetail :purchaseDetailDialog.sync="orderPurchaseDetailDialog" v-if="orderPurchaseDetailDialog" :orderPurchaseId="related_id"/>
        <!--应付详情-->
       <PayableDetailsDialog v-if="payableDetailsDialogVisible"  :payableDetailsDialogVisible.sync="payableDetailsDialogVisible" :payable_no="related_num"  />
        <!--坏账详情-->
       <UnpaidPaymentDetails  v-if="unpaidDetailsDialogVisible" :unpaidDetailsDialogVisible.sync="unpaidDetailsDialogVisible"  :order_num="related_num" @btnOperate="successRefresh"/>
   </div>
</template>
<script>
import { groupGetStageAndTask,getAutoSaveStagePushInfo,stagePush,projectDel,ProjectManageMemberDel,ProjectManageRelateCancel,orderHasAfterSale} from "@/api/index.js"
import businessAdd from "../../Business/component/business_add";
import businessEdit from "../../Business/component/business_edit";
import quotationTemplate from "../../Business/component/quotation_template";
import changeThePerson from "../../Business/component/change_the_person";
import addMember from "../../Business/component/add_member";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import OutProductDetail from "../../InventoryManagement/component/out_product_detail"//出库详情
import InProductDetail from "../../InventoryManagement/component/in_product_detail"//入库详情
import PurchaseDetail from "../../Purchase/component/purchase_detail"; //采购详情
import MemberTpl from "./member_tpl";
import OrderAdd from  "../../Order/component/order_add"
import OrderEdit from  "../../Order/component/order_edit"
import OrderAfterSale from  "../../Order/component/order_afte_sale"
import InvoiceDialog from "@/views/pc/Order/component/invoice_dialog";
import InvoiceDetailsDialog from "@/views/pc/Order/component/invoice_details";
import RepaymentDialog from "@/views/pc/Order/component/repayment_dialog";
import RepaymentDetail from "@/views/pc/Order/component/repayment_details";
import ProductCostDetail from  "./product_cost_detail"
import OrderPurchaseDetail from "@/views/pc/Order/component/order_purchase_detail"; //订单代采详情
import PayableDetailsDialog from "@/views/pc/Finance/payable_manage/component/payable_details" //应付详情
import UnpaidPaymentDetails from "@/views/pc/Finance/receivable_manage/component/unpaid_payment_details.vue";
import RelateForm from "./relate_form"
import {mapState} from "vuex";
export default {
    name: "related_handle",
    components: {
        businessAdd,
        businessEdit,
        quotationTemplate,
        changeThePerson,
        addMember,
        CustomFormPc,
        OutProductDetail,
        InProductDetail,
        PurchaseDetail,
        RelateForm,
        MemberTpl,
        OrderAdd,
        OrderEdit,
        OrderAfterSale,
        RepaymentDialog,
        RepaymentDetail,
        InvoiceDialog,
        InvoiceDetailsDialog,
        ProductCostDetail,
        OrderPurchaseDetail,
        PayableDetailsDialog,
        UnpaidPaymentDetails
    },
    computed: {
        ...mapState(['tagList'])
    },
    props: {

    },
    data() {
        return {
            loading:false,
            projectId:null,//项目id
            projectDetail:{},//项目详情内容
            relatedHandleType:'',
            relatedHandleData:null,
            related_id:0,
            related_num:'',
            related_ids:[],
            orderAfterSaleInfo:{}, //订单售后参数
            addBusinessDialogVisible:false,
            editBusinessDialogVisible:false,
            changeThePersonDialogVisible:false,
            addMemberDialogVisible:false,
            stageTaskDialogVisible:false,
            addQuotationDialogVisible:false,
            outProductDetailDialog:false,
            inProductDetailDialog:false,
            purchaseDetailVisible:false,
            relateFormDialog:false,
            memberDialog:false,
            addOrderDialogVisible:false,
            editOrderDialogVisible:false,
            orderAfterSaleDialog:false,
            repaymentDialogVisible:false,
            repaymentDetailDialogVisible:false,
            invoiceDialogVisible:false,
            invoiceDetailsDialogVisible:false,
            productCostDetailDialog:false,
            orderPurchaseDetailDialog:false,
            payableDetailsDialogVisible:false,
            unpaidDetailsDialogVisible:false,
            nextStageId : 0,
            stageTaskFieldsList : [],
            stageTaskFieldsFormDetail : {},
            currentProjectStageId:0,
            btnDisabled:false,
        }
    },
    created() {

    },
    methods: {
        handleClickRelateHandle(type,data){
            this.relatedHandleType = type
            this.relatedHandleInfo = data
            this.related_id = 0
            this.related_ids = []
            if(type == 'business_detail'){
                this.handleClickBusinessDetail(this.relatedHandleInfo) //查看商机详情
            }else if(type == 'company_detail'){
                this.handleClickRelateCompanyDetail(this.relatedHandleInfo) //查看客户详情
            }else if(type == 'edit_business'){
                this.handleClickEditBusiness() //编辑商机
            }else if(type == 'add_business'){
                this.handleClickAddBusiness() //新增商机
            }else if(type == 'view_the_quotation'){
                this.handleClickViewTheQuotation(this.relatedHandleInfo) //查看报价单
            }else if(type == 'advance_next_stage'){
                this.handleClickAdvanceNextStage() //商机推进阶段
            }else if(type == 'business_change_person'){
                this.handleClickChangeThePersonBusiness()//商机更换负责人
            }else if(type == 'add_New_quotation'){
               this.handleClickAddNewQuotation() //商机新增报价
            }else if(type == 'add_member_business'){
                this.handleClickAddMemberBusiness()//商机添加成员
            }else if(type == 'del_business'){
                this.handleClickDelBusiness()//商机删除
            }else if(type == 'business_disassociation'){
                this.handleClickBusinessDisassociation() //取消关联商机
            }else if(type == 'payment'){
                this.handleClickAddPayment() //新建回款
            }else if(type == 'invoice'){
                this.handleClickAddInvoice() //新建开票
            }else if(type == 'payment_detail'){
                this.handleClickPaymentDetail() //回款详情
            }else if(type == 'invoice_detail'){
                this.handleClickInvoiceDetail() //开票详情
            }else if(type == 'add_out_record'){
                this.handleClickAddOutWarehouse() //新建出库
            }else if(type == 'add_in_record'){
                this.handleClickAddInWarehouse() //新建入库
            }else if(type == 'approval_detail'){ //审批详情
                this.handleClickApprovalDetail()
            }else if(type == 'out_record_detail'){ //出库详情
                this.handleClickOutDetail()
            }else if(type == 'in_record_detail'){ //入库详情
                this.handleClickInDetail()
            }else if(type == 'purchase'){ //采购详情
                this.handleClickPurchaseDetail()
            }else if(type == 'approval_disassociation'){
                this.handleClickApprovalDisassociation() //取消关联审批
            }else if(type == 'relate_business'){
               this.relateFormDialog = true // 关联商机
            }else if(type == 'relate_order'){
                this.relateFormDialog = true// 关联订单
            }else if(type == 'relate_work_order'){
                this.relateFormDialog = true// 关联工单
            }else if(type == 'relate_approval'){
                this.relateFormDialog = true// 关联审批
            }else if(type == 'add_approval'){
                this.relateFormDialog = true//新增审批
            }else if(type == 'add_member'){
                this.handleClickAddMember()//添加成员
            }else if(type == 'edit_member'){
                this.handleClickEditMember()//编辑成员
            }else if(type =='del_member'){
                this.handleClickDelMember()//删除成员
            }else if(type == 'add_order'){
                this.handleClickAddOrder() //订单新增
            }else if(type =='order_detail'){
                this.handleClickOrderDetail(this.relatedHandleInfo)//订单详情
            }else if(type =='after_sales'){
                this.handleClickOrderAfterSales(this.relatedHandleInfo)//订单售后
            }else if(type == 'order_disassociation'){
                this.handleClickOrderDisassociation() //取消关联订单
            }else if(type == 'order_purchase_detail'){
                this.handleClickOrderPurchaseDetail() //订单代采详情
            }else if(type == 'product_cost_detail'){
                this.productCostDetailDialog = true //产品成本详情
            }else if(type == 'payable_detail'){
                this.handleClickPayableDetail() //采购应付详情
            }else if(type == 'work_order_detail'){
                this.handleClickWorkOrderDetail() // 工单详情
            }else if(type == 'add_work_order'){
                this.handleClickAddWorkOrder()// 新建工单
            }else if(type == 'work_order_disassociation'){
                this.handleClickWorkOrderDisassociation()// 取消关联工单
            }else if(type == 'stock_related_detail'){
                this.handleClickStockRelatedDetail()  //库存关联的业务详情
            }else if(type == 'copy'){
                this.handleClickCopy(this.relatedHandleInfo.text)
            }else if(type == 'finance_bad_debt_detail'){
                this.related_num = this.relatedHandleInfo.related_num
                this.unpaidDetailsDialogVisible = true //订单坏账
            }
        },
        //点击查看商机详情
        handleClickBusinessDetail({project_id, name}) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },
        //点击查看关联客户详情
        handleClickRelateCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id.value,
                    name: row.customer_id.text,
                },
            });
        },
        //新增商机事件
        handleClickAddBusiness() {
            this.addBusinessDialogVisible = true
        },
        // 编辑商机
        handleClickEditBusiness(){
            this.related_id = this.relatedHandleInfo.project_id
            this.editBusinessDialogVisible = true
        },
        // 商机推进阶段
        handleClickAdvanceNextStage() {
            let row = this.relatedHandleInfo
            groupGetStageAndTask({
                project_group_id: row.project_group_id
            }).then(res => {
                if (res.code === 200) {
                    const currentStage = res.data.find(item => item.project_stage_id === row.project_stage.value) || {}
                    if (currentStage && currentStage.sort === res.data.length) return this.$message.error('已经是最后一阶段，无法推进')
                    this.currentProjectStageId = currentStage.project_stage_id
                    this.related_id = row.project_id
                    this.nextStageId = res.data[currentStage.sort].project_stage_id
                    const field = {
                        field_form: "projects",
                        field_key: currentStage.project_stage_id,
                        field_name: currentStage.name + '任务',
                        field_type: "form_module",
                        extend: {
                            is_form_show: true
                        },
                        sort: currentStage.sort,
                        _child: currentStage.tasks
                    }
                    this.stageTaskFieldsList = [field]
                    if (this.stageTaskFieldsList.length) {
                        getAutoSaveStagePushInfo({
                            project_id: row.project_id,
                            project_stage: currentStage.project_stage_id,
                        }).then(res => {
                            if (res.code === 200) {
                                field._child.forEach(child => {
                                    if (row.hasOwnProperty(child.field_key)) {
                                        this.$set(this.stageTaskFieldsFormDetail, child.field_key, row[child.field_key])
                                    }
                                    if (res.data && res.data.hasOwnProperty(child.field_key)) {
                                        const field_value = res.data[child.field_key]
                                        if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' && field_value.value !== undefined && field_value.value.length !== 0))) {
                                            this.$set(this.stageTaskFieldsFormDetail, child.field_key, field_value)
                                        }
                                    }
                                })
                                this.stageTaskDialogVisible = true
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {

                    }
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        //商机推进弹窗取消
        handleClickStageTaskDialogCancel() {
            this.stageTaskDialogVisible = false
            this.nextStageId = 0
            this.stageTaskFieldsList = []
            this.stageTaskFieldsFormDetail = {}
        },
        //商机推进弹窗确定
        handleClickStageTaskDialogConfirm() {
            this.$refs.stage_task_form.handleClickPublish()
        },

        submitTaskFormData(data) {
            stagePush({
                project_id: this.related_id,
                project_stage: this.nextStageId,
                ...data
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('推进成功')
                    this.handleClickStageTaskDialogCancel()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 商机更换负责人
        handleClickChangeThePersonBusiness(){
            this.related_ids = [this.relatedHandleInfo.project_id]
            this.changeThePersonDialogVisible = true
        },
        // 新增商机报价
        handleClickAddNewQuotation(){
            this.related_id = this.relatedHandleInfo.project_id
            this.addQuotationDialogVisible = true
        },
        // 商机添加成员
        handleClickAddMemberBusiness(){
            this.related_id = this.relatedHandleInfo.project_id
            this.addMemberDialogVisible = true
        },
        // 商机删除
        handleClickDelBusiness(){
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectDel({
                    project_id: [this.relatedHandleInfo.project_id]
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },
        // 取消商机关联
        handleClickBusinessDisassociation(){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消关联',
                message: h('div', null, [
                    h('span', null, '确定要取消关联吗？取消后所相关的数据将同步清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.project_id,
                    relate_type: 'project',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$message.success('取消关联成功')
                        this.successRefresh()
                    }
                })
            }).catch(() => {

            })
        },
        // 取消关联审批
        handleClickApprovalDisassociation(){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消关联',
                message: h('div', null, [
                    h('span', null, '确定要取消关联吗？取消后所相关的数据将同步清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.relate_id,
                    relate_type: 'approval',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$message.success('取消关联成功')
                        this.successRefresh()
                    }
                })
            }).catch(() => {

            })
        },
        // 取消关联订单
        handleClickOrderDisassociation(){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消关联',
                message: h('div', null, [
                    h('span', null, '确定要取消关联吗？取消后所相关的数据将同步清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.order_id,
                    relate_type: 'order',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$message.success('取消关联成功')
                        this.successRefresh()
                    }
                })
            }).catch(() => {

            })


        },
        // 取消关联工单
        handleClickWorkOrderDisassociation(){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消关联',
                message: h('div', null, [
                    h('span', null, '确定要取消关联吗？取消后所相关的数据将同步清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.id,
                    relate_type: 'workorder',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$message.success('取消关联成功')
                        this.successRefresh()
                    }
                })
            }).catch(() => {

            })


        },
        // 查看报价单
        handleClickViewTheQuotation({project_quotation_id, title}){
            this.$router.push({
                name: "QuotationDetails",
                params: {
                    isPush: true,
                },
                query: {
                    project_quotation_id: project_quotation_id,
                    name: title,
                },
            })
        },
        //新建回款
        handleClickAddPayment(){
            this.repaymentDialogVisible = true
        },
        //新建开票
        handleClickAddInvoice(){
            this.invoiceDialogVisible = true
        },
        //点击查看回款记录详情
        handleClickPaymentDetail() {
            this.related_num = this.relatedHandleInfo.receivable_no
            this.repaymentDetailDialogVisible = true
        },
        //点击查看开票详情
        handleClickInvoiceDetail() {
            this.related_num = this.relatedHandleInfo.invoice_no
            this.invoiceDetailsDialogVisible = true
        },
        // 新建出库
        handleClickAddOutWarehouse(){
            let index = this.tagList.findIndex(find => find.name == 'OutWarehouseAdd')
            this.$router.push({
                name: 'OutWarehouseAdd',
                query:{
                    project_manage_id:this.projectId
                },
                params: {
                    isPush: index > -1 ? false  : true
                }
            })
        },
        // 新建入库
        handleClickAddInWarehouse(){
            let index = this.tagList.findIndex(find => find.name == 'InWarehouseAdd')
            this.$router.push({
                name: 'InWarehouseAdd',
                query:{
                    project_manage_id:this.projectId
                },
                params: {
                    isPush: index > -1 ? false  : true
                }
            })
        },
        // 出库详情
        handleClickOutDetail(){
            this.related_id = this.relatedHandleInfo.id
            this.outProductDetailDialog = true
        },
        // 入库详情
        handleClickInDetail(row){
            this.related_id = this.relatedHandleInfo.id
            this.inProductDetailDialog = true
        },
        // 采购详情
        handleClickPurchaseDetail(){
           this.related_id = this.relatedHandleInfo.id
           this.purchaseDetailVisible = true
        },
        // 审批详情
        handleClickApprovalDetail() {
            this.$showApprovalDetail({
                approval_id: this.relatedHandleInfo.approval_id ,
            }).then((res) => {

            });
        },
        // 删除成员
        handleClickDelMember(){
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                ProjectManageMemberDel({
                    id:this.relatedHandleInfo.id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.successRefresh()
                    }
                }).catch(() => {

                })

            }).catch(() => {

            })
        },
        // 编辑成员
        handleClickEditMember(){
            this.related_id = this.relatedHandleInfo.id
            this.memberDialog = true
        },
        // 添加成员
        handleClickAddMember(){
            this.memberDialog = true
        },
        // 新增订单
        handleClickAddOrder(){
            this.addOrderDialogVisible = true

        },
        // 订单详情
        handleClickOrderDetail(row){
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id ? row.order_id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.order_id ? undefined : 'order_num'
                },
            });
        },
        // 编辑订单
        handleClickEditOrder(){
            this.related_id = this.relatedHandleInfo.order_id
            this.editOrderDialogVisible = true
        },
        // 订单售后
        handleClickOrderAfterSales(){
            this.related_id = this.relatedHandleInfo.order_id
            this.orderAfterSaleInfo = {
                customer_name: this.relatedHandleInfo.customer_name,
                order_num: this.relatedHandleInfo.order_num
            }
            orderHasAfterSale({
                order_id: this.relatedHandleInfo.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips)
                    } else {
                        this.orderAfterSaleDialog = true
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 订单代采详情
        handleClickOrderPurchaseDetail(){
            this.related_id = this.relatedHandleInfo.id
            this.orderPurchaseDetailDialog = true
        },
        // 采购应付详情
        handleClickPayableDetail(){
            this.related_num = this.relatedHandleInfo.id
            this.payableDetailsDialogVisible = true
        },
        //新建工单
        handleClickAddWorkOrder() {
            this.$router.push({
                name: "WorkOrderAdd",
                params: {
                    isPush: true,
                },
                query: {},
            });
        },
        //工单详情
        handleClickWorkOrderDetail() {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: this.relatedHandleInfo.id,
                    name: this.relatedHandleInfo.work_order_num,
                },
            });
        },
        // 库存关联业务详情
        handleClickStockRelatedDetail(){
            if(this.relatedHandleInfo.related_info.related_type == 'purchase'){
                this.related_id = this.relatedHandleInfo.related_info.related_id
                this.purchaseDetailVisible = true
            }else if(this.relatedHandleInfo.related_info.related_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:this.relatedHandleInfo.related_info.related_id,
                        name:this.relatedHandleInfo.related_info.related_num,
                    },
                });
            }
        },
        // 复制
        handleClickCopy(text) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },
        // 操作成功回调
        successRefresh(data){
            console.log(data);
            this.$emit('relatedHandleSuccess',{type:this.relatedHandleType})
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
